interface ContentInitialValue {
  nome: string;
}

export function getFilteredContent<ContentType extends ContentInitialValue>(
  content: ContentType[],
  text: string
): ContentType[] {
  const result = content.filter(item =>
    item.nome.toLowerCase().includes(text.trim().toLowerCase())
  );
  return result;
}
